import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

const About = () => {
  const { data: aboutContent, isLoading } = useQuery({
    queryKey: ["about-content"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("sns_about_content")
        .select(`
          *,
          images:sns_about_images(*)
        `)
        .single();
      
      if (error) throw error;
      return data;
    },
  });

  if (isLoading) {
    return (
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="h-64 bg-gray-200 rounded-lg animate-pulse" />
            <div className="space-y-4">
              <div className="h-8 bg-gray-200 rounded animate-pulse w-3/4" />
              <div className="h-24 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-white relative z-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-up">
            {aboutContent?.video_url ? (
              <div className="rounded-lg shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
                <video
                  src={aboutContent.video_url}
                  controls
                  className="w-full h-auto"
                  poster={aboutContent.images?.[0]?.image_url}
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            ) : aboutContent?.images?.length > 0 ? (
              <img
                src={aboutContent.images[0].image_url}
                alt="About Shell & Sand"
                className="rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300"
              />
            ) : (
              <img
                src="https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600"
                alt="About Shell & Sand"
                className="rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300"
              />
            )}
          </div>
          <div className="animate-fade-up" style={{ animationDelay: "150ms" }}>
            <h2 className="text-4xl font-bold mb-8 text-travel-dark">
              {aboutContent?.title || "About Shell & Sand"}
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              {aboutContent?.description || "Discover the pristine beauty of the Maldives with Shell & Sand, your trusted partner for unforgettable island experiences."}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;